import { jwtDecode } from "jwt-decode";

export const isAuthenticated = () => {
  return !isTokenExpired();
};

export const isTokenExpired = () => {
  const token = localStorage.getItem("token");
  if (!token) return true;

  try {
    const decodedToken = jwtDecode(token);
    const isExpired = decodedToken.exp * 1000 < Date.now();
    return isExpired;
  } catch (err) {
    console.error("Invalid token", err);
    return true;
  }
};

export const getUser = () => {
  const token = localStorage.getItem("token");
  if (!token) return false;

  try {
    const decodedToken = jwtDecode(token);
    const user = decodedToken;
    return user;
  } catch (err) {
    console.error("Invalid token", err);
    return false;
  }
};

export const logout = () => {
  localStorage.removeItem("token");
};
